import NsqfNonNsqfCards from "../component/HomePageComponent/NsqfNonNsqfCards";
import AllCourses from "../component/layout/AllCourses";
import CarouselComponent from "../component/layout/CarouselComponent";
import Footer from "../component/layout/Footer";
import Header from "../component/layout/Header";
import HomeBackground from '../assets/images/HomeBackground.png';
import pair from "../assets/images/home/pair.png";
import homeTop from "../assets/images/homeTop.png";

import automation from "../assets/images/Automation.png";
import ai from "../assets/images/AI.png";
import gs from "../assets/images/Genral_Safety.png";
import da from "../assets/images/Data_Analysis.png";
import fs from "../assets/images/Fire_safety.png";
import evst from "../assets/images/Electric_vechile_service (1).jpg";
import AllCourseCard from "../component/HomePageComponent/AllCourseCard";
import InfoSection from "../component/HomePageComponent/InfoSection";
import AboutUs from "../component/HomePageComponent/AboutUs";
import SecondInfo from "../component/HomePageComponent/SecondInfo";
import Testimonials from "../component/HomePageComponent/Testimonials";
import JoinUs from "../component/HomePageComponent/JoinUs";
import mab from "../assets/images/home/mobile_app_Home_Page.png";
import { redirect, useNavigate } from "react-router-dom";
import Layout from "../component/layout/Layout";
import cnco from "../assets/images/home/cnco.png";
import cncot from "../assets/images/home/cncot.png";
import ldrshp from "../assets/images/home/ldrshp.png";
import teamb from "../assets/images/home/teamb.png";
import timem from "../assets/images/home/timem.png";
import cnt from "../assets/images/home/cnt.png";
import amo from "../assets/images/home/amo.png";
import vmco from "../assets/images/home/vmco.png";
import PopularCourseCard from "../component/HomePageComponent/PopularCourseCard";
import AppDownload from "../component/HomePageComponent/AppDownload";
import HeroSection from '../component/HomePageComponent/HeroSection';
import PopularCoursesModule from '../component/HomePageComponent/PopularCourseModuel';
import AllCoursesModule from '../component/HomePageComponent/AllCoursesModule';
import OurClientsSection from "../component/HomePageComponent/OurClients";
import OfflineTrainingPromo from "../component/HomePageComponent/SkillServeAcademy";

const Home = () => {
    const navigate = useNavigate();

    const handleMouseOver = (e) => {
        e.target.style.transform = "scale(1.05)"; // Slightly scale up on hover
        e.target.style.boxShadow = "0px 8px 20px rgba(0, 0, 0, 0.2)"; // Increase shadow on hover
        e.target.style.backgroundColor = "#FF7F00"; // Darker orange color on hover
        e.target.style.color = "#f0f0f0"; // Change text color to light gray
        e.target.style.position = "relative"; // Ensure positioning for shine effect
        const shine = document.createElement('div');
        shine.style = shineEffect;
        e.target.appendChild(shine); // Add the shine effect
    };

    const handleMouseOut = (e) => {
        e.target.style.transform = "scale(1)"; // Reset scale on mouse out
        e.target.style.boxShadow = "0px 4px 6px rgba(0, 0, 0, 0.1)"; // Reset shadow
        e.target.style.backgroundColor = "#FFA800"; // Reset to original background color
        e.target.style.color = "#FFFFFF"; // Reset text color
        const shine = e.target.querySelector("div");
        if (shine) e.target.removeChild(shine); // Remove shine effect when mouse leaves
    };
    return (
        <>

            <Layout>
                {/* replaced hero */}
                <HeroSection />

                {/* modules placed like other components (below hero & above InfoSection) */}
                <PopularCoursesModule />

                <AllCoursesModule />
                <div className="row">
                    <OfflineTrainingPromo/>
                </div>

                {/* existing modules */}
                <div className="row">
                    <InfoSection />
                </div>

                <div className="row">
                    <AboutUs />
                </div>

                <div className="row">
                    <SecondInfo />
                </div>

                <div className="row">
                    <OurClientsSection/>
                </div>

                <div className="row">
                    <Testimonials />
                </div>


                <div className="row">
                    <AppDownload/>
                </div>

                <div className="row">
                    <JoinUs />
                </div>
            </Layout >


        </>
    )
}

const buttonStyle = {
    backgroundColor: "#FFA800", // Orange color
    color: "#FFFFFF", // White text
    border: "none",
    borderRadius: "20px", // Rounded corners
    padding: "6px 14px", // Adjust padding for size
    fontSize: "1.3rem", // Adjust font size
    fontWeight: "bold",
    cursor: "pointer",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", // Optional shadow
    position: "relative", // Position for the shine effect
    overflow: "hidden", // Hide the shine effect overflow
    transition: "all 0.3s ease", // Smooth transition for background, scale, and shadow
};

const shineEffect = {
    content: "",
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "300%",
    height: "300%",
    background: "linear-gradient(45deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.2))",
    transform: "translate(-50%, -50%) rotate(45deg)",
    animation: "shine 1s infinite",
};

export default Home;
